export const NOTIF_DURATION = 4000;
